import styled from "styled-components";

export const MusicPracticeRoomStyled = styled.div`
  .musicroom_img {
    margin-bottom: 14px;
    width: 100%;
    height: auto;
  }
  .musicroom_text {
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
  }
`;
